/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DragHandle from 'app/components/common/DragHandle.jsx';
import PostImage from 'app/components/common/PostImage.jsx';
import PostSource from 'app/components/common/PostSource.jsx';
import PostModalScheduleOverlay from 'app/components/PostModal/PostModalScheduleOverlay.jsx';
import PostListUtilities from 'app/modules/PostListUtilities.jsx';
import ItemCategoryTag from 'app/components/Queue/ItemCategoryTag.jsx';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';
import EmblaCarousel from 'app/components/common/EmblaCarousel.jsx';
import EverqueuePlaceholder from 'app/components/common/EverqueuePlaceholder.jsx';

class QueuePostDetailComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            overlay: false,
            scheduleTime: null,
            showMobileControls: false
        };

        this.showOverlay = this.showOverlay.bind(this);
        this.hideOverlay = this.hideOverlay.bind(this);
        this.reschedule = this.reschedule.bind(this);
        this.toggleMobileControls = this.toggleMobileControls.bind(this);

    }

    showOverlay() {

        this.setState({
            overlay: true
        });

    }

    hideOverlay() {

        this.setState({
            overlay: false
        });

    }

    reschedule(val) {

        let scheduleTime = moment(val),
            timestamp = scheduleTime.toISOString(),
            itemId = this.props.post.id;

        this.props.rescheduleMethod(timestamp, itemId);

        this.setState({overlay: false});

    }

    toggleMobileControls(e) {

        this.setState({
            showMobileControls: !this.state.showMobileControls
        });

    }

    render() {

        let post = this.props.post,
            comment = '',
            time = null,
            overlay = '',
            lock = '',
            classNames = 'item-row queue-item-row',
            imageClass = 'item-image queue-item-image',
            draggable = true,
            repost = '',
            itemControls = null,
            itemDate = null,
            timeLabel = '',
            urlReg = /(\b((https?|ftp|file:\/\/)|www[.])[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig,
            categoryDisplay = null,
            category = null,
            dragHandle = (
                <DragHandle item={post}/>
            ),
            retweet = null,
            mobileDate = null;

        if (post.itemTimeStamp && this.props.user.detail.timezone) {
            time = moment.tz(post.itemTimeStamp * 1000, this.props.user.detail.timezone)
            timeLabel = time.format('h:mm A');
        }

        /*
            A post with a time of its own goes out then, wherever it sits in the queue. The
            Everqueue's placeholder writes its 0 as a string, hence the Number().
        */
        if (Number(post.post_ts)) {
            lock = <i className="fa fa-lock fa-lg" role="img" aria-label="scheduled"></i>;
            draggable = false;
        }

        if (this.props.handle === '' || this.props.category !== null) {
            draggable = false;
        }

        if (!draggable) {
            dragHandle = null;
        }

        mobileDate = (
            <div className="item-date queue-item-date">
                {lock} {timeLabel}
            </div>
        );

        if (this.props.item.deleted) {
            classNames += ' deleted';
            itemDate = (
                <div className="item-date queue-item-date">
                    <div className="marked-for-deletion">
                        <i className="icon ion-ios-trash-outline"></i>
                    </div>
                </div>
            );
        } else {
            itemDate = (
                <div className="item-date queue-item-date">
                    {lock} {timeLabel}
                </div>
            );
            itemControls = (
                <div className="item-controls queue-item-controls">
                    <div className="item-control queue-item-control" data-itemid={post.id} onClick={this.props.moveToTop} role="button" aria-label="move to top">
                        <i className="icon ion-ios-arrow-thin-up"></i>
                    </div>
                    <div className="item-control queue-item-control" data-itemid={post.id} onClick={this.showOverlay} role="button" aria-label="reschedule">
                        <i className="icon ion-ios-time-outline"></i>
                    </div>
                    <div className="item-control queue-item-control" data-itemid={post.id} onClick={this.props.postModalMethod} role="button" aria-label="edit">
                        <i className="icon ion-ios-compose-outline"></i>
                    </div>
                    <div className="item-control queue-item-control" data-itemid={post.id} onClick={this.props.removeMethod.bind(null, this.props.item)} role="button" aria-label="delete">
                        <i className="icon ion-ios-trash-outline"></i>
                    </div>
                </div>
            );
            if (lock !== '') {
                itemControls = (
                    <div className="item-controls queue-item-controls">
                        <div className="item-control queue-item-control empty"></div>
                        <div className="item-control queue-item-control" data-itemid={post.id} onClick={this.showOverlay} role="button" aria-label="reschedule">
                            <i className="icon ion-ios-time-outline"></i>
                        </div>
                        <div className="item-control queue-item-control" data-itemid={post.id} onClick={this.props.postModalMethod} role="button" aria-label="edit">
                            <i className="icon ion-ios-compose-outline"></i>
                        </div>
                        <div className="item-control queue-item-control" data-itemid={post.id} onClick={this.props.removeMethod.bind(null, this.props.item)} role="button" aria-label="delete">
                            <i className="icon ion-ios-trash-outline"></i>
                        </div>
                    </div>
                );
            }

        }

        if (post.id == "-1") {
            itemControls = null;
        }

        if (this.state.overlay) {
            overlay = (
                <PostModalScheduleOverlay
                    user={this.props.user}
                    hideOverlay={this.hideOverlay}
                    scheduleHandler={this.reschedule}
                    initialScheduleTime={time}/>
            );
        }

        if (post.repost.length && this.props.user.perms.resources.repost) {
            repost = (
                <span>
                    <i className="fa fa-refresh"></i>{' '}
                </span>
            );
        }

        comment = PostListUtilities.generateListComment(post, repost);

        if (parseInt(post.tagID, 10) !== 0 && !isNaN(parseInt(post.tagID, 10))) {
            category = _.find(this.props.categoryList, function(category) {
                return (parseInt(category.id, 10)) === (parseInt(post.tagID, 10));
            });
            if (category) {
                categoryDisplay = (
                    <ItemCategoryTag category={category}/>
                );
            }
        }

        if (this.props.item.tweet_id !== 0) {
            retweet = (
                <div className="retweet-indicator inline">
                    <i className="ds-icon icon-retweet"/>
                </div>
            )
        }

        let title = '',
            body = '';

        if (post.preview.title) {
            title = post.preview.title;
        } else if (post.preview.itemInfo !== undefined && post.preview.itemInfo.title) {
            title = post.preview.itemInfo.title;
        }

        if (!comment && !post.preview.comment && !post.preview.status && !post.preview.message) {
            if (post.preview.body) {
                body = post.preview.body;
            } else if (post.preview.itemInfo !== undefined && post.preview.itemInfo.summary) {
                body = post.preview.itemInfo.summary;
            }
        }

        let previewImage = null;
        if (post.preview.media && post.preview.media.length) {
            if (post.preview.media.length > 1) {
                imageClass += ' multi';
                previewImage = (
                    <EmblaCarousel options={{
                        container: ".carousel-slide-wrapper",
                        slide: ".carousel-slide",
                        align: 'start',
                        loop: true
                    }}
                    extraClasses={'queue'}
                    mode='queue-view'>
                        {post.preview.media.map((media, i) => {
                            return(
                                <PostImage
                                    {...this.props}
                                    key={`${post.id}-image-${i}`}
                                    src={media.thumb}/>
                            );
                        })}
                    </EmblaCarousel>
                )
            } else {
                previewImage = (
                    <PostImage
                        {...this.props}
                        item={post}/>
                );
            }
        } else {
                previewImage = (
                    <PostImage
                        {...this.props}
                        item={post}/>
                );
            }

        if (title.match(/everqueue/i)) {
            previewImage = <EverqueuePlaceholder/>
        }

        return (
            <div>
                <Breakpoint desktop only>
                    <div className={classNames}
                        id={post.id}
                        data-pw="queue-post"
                        draggable={draggable}
                        onDragStart={this.props.dragStart}
                        onDragOver={this.props.dragOver}
                        onDragLeave={this.props.dragLeave}
                        onDrop={this.props.dragEnd}>
                        <div className="item">
                            {categoryDisplay}

                            <div className={imageClass}>
                                {previewImage}
                            </div>
                            <div className="item-share queue-item-share">
                                {itemDate}
                                {itemControls}
                            </div>
                            <div className="item-details queue-item-details">
                                <div className="item-summary queue-item-summary">
                                    {repost}
                                    <div className="ellipsis item-headline item-title" alt={title} title={title}>{title}</div>
                                    {comment}
                                    <div className="post-preview-body ellipsis item-summary">{body}</div>
                                </div>
                                <PostSource input={this.props.input} retweet={retweet}/>
                            </div>
                            {overlay}
                            {dragHandle}
                        </div>
                    </div>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className={classNames}
                        id={post.id}>
                        {categoryDisplay}
                        <div className="item-edit">
                            {mobileDate}
                            <div onClick={this.toggleMobileControls} role="button" aria-label="show controls">
                                <i className="icon ion-gear-b"></i>
                            </div>
                        </div>
                        <div className="mobile-queue-content clearfix">
                            <div className="item-image queue-item-image">
                                <PostImage
                                    {...this.props}
                                    item={post}/>
                            </div>
                            <div className="item-details queue-item-details">
                                <div className="item-summary queue-item-summary">
                                    <div className="item-headline item-title" alt={title} title={title}>{title}</div>
                                    {comment}
                                    <div className="post-preview-body item-summary">{body}</div>
                                </div>
                            </div>
                        </div>
                        {overlay}
                        {(this.state.showMobileControls) ? itemControls : null}
                    </div>
                </Breakpoint>
            </div>
        );

    }

};

QueuePostDetailComponent.displayName = "QueuePostDetailComponent";

QueuePostDetailComponent.propTypes = {
    editItem: PropTypes.func,
    input: PropTypes.object,
    index: PropTypes.number,
    moveToTop: PropTypes.func,
    post: PropTypes.object,
    postType: PropTypes.string,
    postModalMethod: PropTypes.func,
    removeMethod: PropTypes.func,
    rescheduleMethod: PropTypes.func
};

QueuePostDetailComponent.defaultProps = {
    editItem: null,
    index: -1,
    input: {},
    moveToTop: null,
    post: {},
    postType: 'status',
    postModalMethod: null,
    removeMethod: null,
    rescheduleMethod: null
};

export default QueuePostDetailComponent;
